import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ResetPasswordForm } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/ResetPasswordForm';
import { McBookieResetPasswordFormTerms } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/McBookieResetPasswordFormTerms';
import { ResetPasswordRhsRouteType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    currentRoute: ResetPasswordRhsRouteType;
}

export const ResetPasswordProcedure = observer('ResetPasswordProcedure', (props: PropsType) => {
    const { currentRoute } = props;
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const { resetPasswordForm } = configComponents.config;

    if (resetPasswordForm === 'McBookieValidateAccountForm' || currentRoute.isVerify === true) {
        return <McBookieResetPasswordFormTerms currentRoute={currentRoute} />;
    }

    return <ResetPasswordForm currentRoute={currentRoute} />;
});
